
import React, {FC} from 'react';
import {navigate} from 'gatsby';
import {Action, State, Step} from 'templates/booking/Booking/reducer';
import {createSuccessLink} from 'templates/booking/Success/useSuccess';

import CheckAppt from './Screens/CheckAppt';
import CheckExit from './Screens/CheckExit';
import ConfirmAppt from './Screens/ConfirmAppt';
import Error from './Screens/Error';
import Expired from './Screens/Expired';
import Pricing from './Screens/Pricing';
import RenewEarly from './Screens/RenewEarly';
import {parseResult} from './parse';

type ContentProps = {
	state: State
	dispatch: React.Dispatch<Action>
}

const Content: FC<ContentProps> = ({state, dispatch}) => {
	const {appt, credits, membership} = parseResult(state);
	if (!appt) {
		return null;
	}

	switch (state.step) {
	case Step.CheckExit:
		return (
			<CheckExit
				onExit={() => dispatch({type: 'EXIT-CONFIRM'})}
				onCancel={() => dispatch({type: 'EXIT-CANCEL'})}
			/>
		);

	case Step.CheckAppt:
		if (credits.count === 0) {
			return (
				<CheckAppt
					appt={appt}
					onPricing={() => dispatch({type: 'APPT-CHECKED'})}
				/>
			);
		}

		return (
			<ConfirmAppt
				appt={appt}
				credits={credits}
				onConfirm={() => {
					// Close our modal
					dispatch({type: 'EXIT-CONFIRM'});

					// Display success page
					navigate(createSuccessLink());
				}}
			/>
		);

	case Step.Expired:
		return (
			<Expired
				onExit={() => dispatch({type: 'EXIT-CONFIRM'})}
			/>
		);

	case Step.Error:
		return (
			<Error
				error={state.error || ''}
				onExit={() => dispatch({type: 'EXIT-CONFIRM'})}
			/>
		);

	case Step.Pricing:
		if (membership.interval) {
			return (
				<RenewEarly
					appt={appt}
					membership={membership}
				/>
			);
		}
		return <Pricing appt={appt} />;
	}

	return null;
};

export default Content;
